/**
 * @module api-web:skuAutoExport/index
 * @description api for data/goods/skuAutoExport
 */
import service from '@/service'

/**
 * 推品列表
 * @param  params
 */
export function getList(data) {
  return service['api-web']({
    url: '/data/product/management/getList',
    method: 'post',
    data
  })
}
/**
 * 新增分类
 * @param  params
 */
export function save(data) {
  return service['api-web']({
    url: '/data/product/management/saveCategory',
    method: 'post',
    data
  })
}

/**
 * @description 查询推品分类详情
 */
export function getProductClassificationById(params) {
  return service['api-web']({
    url: '/public/product/getProductClassificationById',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 编辑分类
 * @param  params
 */
export function update(data) {
  return service['api-web']({
    url: '/data/product/management/updateCategory',
    method: 'post',
    data
  })
}
/**
 * 删除分类
 * @param  params
 */
export function remove(data) {
  return service['api-web']({
    url: '/data/product/management/deleteCategory',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 新增商品查询列表
 * @param  params
 */
export function getAddProductList(data) {
  return service['api-web']({
    url: '/data/product/management/save/getList ',
    method: 'post',
    data
  })
}

/**
 * 新增商品
 * @param  params
 */
export function saveProduct(data) {
  return service['api-web']({
    url: '/data/product/management/save/saveAll',
    method: 'post',
    data
  })
}

/**
 * 删除商品
 * @param  params
 */
export function deleteProduct(data) {
  return service['api-web']({
    url: '/data/product/management/delete',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 商品资料导出
 * @param  params
 */
export function exportData(data) {
  return service['api-web']({
    url: '/data/product/management/productInfoData/export',
    method: 'post',
    data
  })
}
/**
 * @description 下载附件
 */
export function downloadAttachment(params) {
  return service['api-web']({
    url: '/data/product/management/downloadAttachment',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 上传附件
 * @param  params
 */
export function uploadAttachment(data) {
  return service['api-web']({
    url: '/data/product/management/uploadAttachment',
    method: 'post',
    data
  })
}
/**
 * 下载导入模板
 * @param  params
 */
export function downloadExcel(data) {
  return service['api-web']({
    url: 'data/product/management/downloadExcel',
    method: 'post',
    data,
    responseType: 'blob', // 文件流接收类型声明转成 blob
    saveAs: false, // 文件流是否通过浏览器下载
    headers: { 'Content-Type': 'application/json' }
  })
}
/**
 * 导入数据
 * @param  params
 */
export function importProductInfoData(data) {
  return service['api-web']({
    url: '/data/product/management/importProductInfoData',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 上传附件
export function uploadNoSecurityChain(data) {
  return service['api-web']({
    url: '/public/uploadNoSecurityChain',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 *  系统树：商品
 */
export function getGoodsTreeFilter(params) {
  return service['api-web']({
    url: '/data/product/Category/getTreeList',
    method: 'get',
    params
  })
}
